module.exports = __webpack_public_path__ + "img/7.a2e8b53a.svg";